import { createAction, props } from '@ngrx/store';

export const navigateAction = createAction(
  '[NAVIGATION] Navigate',
  props<{ path: string[], extras?: { [key: string]: any } }>()
);
